"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@evidation/ui");
var _icons = require("@evidation/ui/lib/icons");
var VisibilityDropdown = function VisibilityDropdown(_ref) {
  var columns = _ref.columns,
    onToggleColumn = _ref.onToggleColumn,
    isVisible = _ref.isVisible,
    showList = _ref.showList,
    toggleList = _ref.toggleList,
    _ref$props = _ref.props,
    props = _ref$props === void 0 ? {
      container: {},
      label: {},
      value: {},
      toggle: {}
    } : _ref$props;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "visibility-dropdown"
  }, /*#__PURE__*/_react["default"].createElement(_ui.Button, {
    type: "button",
    variant: "ghost",
    className: "btn btn-default btn-sm dropdown-toggle",
    onClick: toggleList
  }, /*#__PURE__*/_react["default"].createElement(_icons.SwitchBoard, null)), /*#__PURE__*/_react["default"].createElement("ul", (0, _extends2["default"])({
    className: "visibility-container show-".concat(showList)
  }, props.container), columns.filter(function (column) {
    return column.header && column.header.label;
  }).map(function (column, columnIndex) {
    var key = "visibility-toggle-".concat(columnIndex);
    return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({
      className: "visibility-label",
      htmlFor: key,
      key: key
    }, props.label), /*#__PURE__*/_react["default"].createElement("a", {
      className: "small",
      "data-value": "option6",
      tabIndex: "-1",
      onClick: function onClick() {
        return onToggleColumn({
          column: column,
          columnIndex: columnIndex
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
      className: "visibility-toggle",
      type: "checkbox",
      id: key,
      checked: isVisible({
        column: column
      }),
      onChange: function onChange() {
        return onToggleColumn({
          column: column,
          columnIndex: columnIndex
        });
      }
    }, props.toggle)), column.header.label));
  })));
};
VisibilityDropdown.propTypes = {
  columns: _propTypes["default"].arrayOf(_propTypes["default"].object).isRequired,
  onToggleColumn: _propTypes["default"].func,
  isVisible: _propTypes["default"].func,
  showList: _propTypes["default"].bool,
  toggleList: _propTypes["default"].func,
  props: _propTypes["default"].shape({
    container: _propTypes["default"].object,
    label: _propTypes["default"].object,
    value: _propTypes["default"].object,
    toggle: _propTypes["default"].object
  })
};
VisibilityDropdown.defaultProps = {
  onToggleColumn: function onToggleColumn(_ref2) {
    var column = _ref2.column,
      columnIndex = _ref2.columnIndex;
  },
  isVisible: function isVisible(_ref3) {
    var column = _ref3.column;
    return column.visible;
  }
};
var _default = exports["default"] = VisibilityDropdown;